
const Loading = ({ message = "Loading..." }) => {
  return (
    <div className="loading-container-custom">
      <div className="spinner-custom" />
      <p className="loading-message-custom">{message}</p>
    </div>
  );
};

export default Loading;